/**
 * Calendar's scheduling-hours reads. Hours change only when Settings saves
 * them, and each save refreshes these queries, so a recent answer is reused
 * across visits instead of cleared and asked again.
 */
export const SCHEDULE_SETTINGS_STALE_MS = 5 * 60_000

/** The working hours a legacy (TENANT_SECRET) clinic's Calendar shades. */
export const calendarScheduleSettingsKey = (tenantId: string) =>
  ['calendar', tenantId, 'clinic-schedule-settings'] as const
